import {AbstractSearchCriteria} from "./abstract-search-criteria";

export class StateSearchCriteria extends AbstractSearchCriteria {
    code: string;
    name: string;
    codeOrName: string;
    countryCode: string;
}
